<app-scc-payment-method-input (ready)="ready = $event">
  <button color="accent" [routerLink]="'/studies'" [disabled]="!ready" mat-raised-button>Renseigner le moyen de paiement plus tard</button>
</app-scc-payment-method-input>
